export default () => ({
    src: '',
    preview: '',
    played: false,

    init() {
        this.src = this.$el.dataset.src;
        this.preview = this.$el.dataset.preview;
    },

    play() {
        this.played = true;
        this.$nextTick(() => {
            this.$refs.videoEl.play();
        });
    }
}); 